<div class="pages_space">

  <div class="row mb-2">
    <div class="col-12 col-md">
      <form>
        <div class="row search_section">
          <div class="col col-md-6 col-lg-4 col-xl-3 pr-lg-0">
          </div>
          <div class="col-auto ">
            <div class="k_button_holder">
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="col-12 col-md-auto mt-2 mt-md-0 text-end">
      <k-button [type]="KButtonType.KLAiMSButton" [label]="'Create New Report'" [color]="'brand-main'"
        [icon]="{type: 'fas', name: 'plus'}" (buttonClick)="openCreateNewReportModal(createNewReportModal, 'add')">
      </k-button>
    </div>
  </div>

  <div class="mt-3">
    <h4>Reports</h4>
    <div *ngIf="this.allReports?.length === 0">
      No data found
    </div>
  </div>

  <div class="docReports">
    <div class="row">
      <div class="col-12 col-lg-6 col-xl-3 iQcard_col" *ngFor="let report of this.allReports">
        <div class="card iQcard item-hover-effect" (click)="viewReport(report, createNewReportModal)">
          <div class="iQcard_header">
            <div class="row">
              <div class="col">

                <div class="headerTitle" title="Report Name">{{report['name']}}</div>
              </div>
              <div class="col-auto pl-0">
                <ul class="card_more_dropdown float-right">
                  <li>
                    <a>
                      <k-icon class="kebab_menu" [icon]="{type: 'image', src: './../assets/images/more.svg'}"></k-icon>
                    </a>
                    <ul>
                      <li (click)="viewReport(report, createNewReportModal)">
                        View
                      </li>
                      <li *ngIf='isDeleteReportAllowed' (click)="confirmDeleteReport(report)">
                        Delete
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="iQcard_body pt-0">
            <p class="mb-0" title="Audiogram date">
              {{report['createdAt'] | date:'dd/MM/yyyy'}}
            </p>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<!-- Modal -->
<ng-template #createNewReportModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title ">Report</h5>
    <button type="button" class="close" aria-label="Close" (click)="closeReportBuilderModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <span>A new audiometry will be saved as:</span>
    <form name="searchMedicalRecordsFilterForm" [formGroup]="reportBuilderForm" #formDir="ngForm">



      <div class="form-group">

        <label class="mb-1 listTitle">
          Report Name <span class="required">*</span>
        </label>
        <input type="text" class="form-control rounded-0" formControlName="reportName" placeholder="Report Name" />
        <div *ngIf="reportBuilderForm.controls.reportName.errors && (formDir.submitted ||
        reportBuilderForm.controls.reportName.dirty ||
        reportBuilderForm.controls.reportName.touched)" class="help-block">
          <small *ngIf="reportBuilderForm.controls.reportName.errors.required">Report name is required.</small>
          <small *ngIf="reportBuilderForm.controls.reportName.errors.pattern">Report name is invalid.</small>
        </div>
      </div>

      <div class="listTitle" *ngIf="taskList?.length > 0">
        Tasks
      </div>
      <div formArrayName="tasks" *ngFor="let i of taskList" class="ps-3">
        <div class="form-check">
          <input class="form-check-input" type="checkbox" name="task{{i.id}}" id="task{{i.id}}" [value]="i.id"
            [checked]="i.checked" (change)="onChangeCheckbox(i,$event,'tasks',reportBuilderForm)">
          <label class="form-check-label" for="task{{i.id}}">{{i.title}}</label>
        </div>
      </div>

      <div class="listTitle" *ngIf="outcomeList?.length > 0">
        Outcome
      </div>
      <div formArrayName="outcome" *ngFor="let i of outcomeList" class="ps-3">
        <div class="form-check">
          <input class="form-check-input" type="checkbox" name="outcome{{i.id}}" id="outcome{{i.id}}" [value]="i.id"
            [checked]="i.checked" (change)="onChangeCheckbox(i,$event,'outcome',reportBuilderForm)">
          <label class="form-check-label" for="outcome{{i.id}}">{{i.title}}</label>
        </div>
      </div>

      <div class="form-group">
        <div class="listTitle" *ngIf="this.medicalRecords">
          Medical Records
        </div>
        <div formArrayName="medicalRecords" *ngFor="let i of this.medicalRecords" class="ps-3">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" name="medicalRecords{{i.id}}" id="medicalRecords{{i.id}}"
              [value]="i.id" [checked]="i.checked"
              (change)="onChangeCheckbox(i,$event,'medicalRecords',reportBuilderForm)">
            <label class="form-check-label" for="medicalRecords{{i.id}}">{{ i.type }} [ {{i.audiogramDate |
              date:'dd/MM/yyyy'}}]</label>
          </div>
        </div>
      </div>


      <div class="form-group">
        <div class="listTitle">
        </div>
      </div>


    </form>
  </div>
  <div class="modal-footer-custom">
    <div class="row">
      <div class="col-auto" *ngIf="showExportBtn()">
        <k-button [type]="KButtonType.KLAiMSButton" [label]="'Export'" [color]="'brand-main'"
          (buttonClick)="exportReport()">
        </k-button>
      </div>
      <div class="col text-end">
        <k-button [type]="KButtonType.KLAiMSButton" [label]="'Cancel'" [subType]="KKcgButtonSubType.Cancel"
          [color]="'dark-grey'" (buttonClick)="closeReportBuilderModal()"></k-button>

        <k-button [type]="KButtonType.KLAiMSButton" [label]="'Save'" [color]="'brand-main'"
          [disabled]="(formDir.submitted && !reportBuilderForm.valid) || !reportBuilderForm.valid"
          (buttonClick)="saveReportBuilder()"></k-button>
      </div>
    </div>
  </div>



</ng-template>
<!-- Modal End -->

<k-simple-alert [display]="displaySuccess" [msgType]="'success'" [message]="successText"
  [timeout]="timeout"></k-simple-alert>
<k-simple-alert [display]="displayError" [msgType]="'error'" [message]="errorText" [timeout]="timeout"></k-simple-alert>